export default __webpack_public_path__ + "static/media/matic_w.161e64e5.svg";